import { SportsLiveListType } from "@/type/list"
import { faMagnifyingGlass, faRotateRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import defaultThumnail from "@/public/image/etc/liveCommon.png"
import { useContext, useEffect, useState } from "react"
import { LiveStreamContext } from "../_config"
import live from "@/public/image/etc/live.png"
import loadingJson from "@/public/media/load_data.json"
import Lottie from "react-lottie-player"
import MultiSelect from "./multi_select"
import RefreshTimer from "./refresh_timer"
import customAlert from "@/util/customAlert"
import { useTranslations } from "next-intl"

export default function LiveSportsListPC({ list }: { list: SportsLiveListType[] }) {
    const [liveList, setLiveList] = useState<SportsLiveListType[]>()
    const [nonLiveList, setNonLiveList] = useState<SportsLiveListType[]>()
    const [loading, setLoading] = useState<boolean>(true)

    const p = useTranslations('PageTitle')
    const a = useTranslations('Sentence')

    useEffect(() => {
        const defaultList = list
        setLiveList(defaultList.filter((el) => el.states == 'ING' && el.video))
        setNonLiveList(defaultList.filter((el) => el.states != 'ING'))
    }, [list])

    useEffect(() => {
        if (liveList && nonLiveList) {
            setLoading(false)
        }
    }, [liveList, nonLiveList])

    return (

        <div className="live-sports-list-PC">
            <div className="page-title">{p('중계 라이브 목록')}
                <RefreshTimer setLoading={setLoading} />
            </div>
            {
                !loading
                    ? !liveList && !nonLiveList
                        ? <ul>
                            {
                                !list || !list.length
                                && <li className="empty">{a('InvalidLive')}</li>
                            }
                        </ul>
                        : <>
                            <ul>
                                {
                                    liveList && liveList.length
                                        ? liveList.map((li, index) => (
                                            <LiveSportsListItem key={index} li={li} />
                                        ))
                                        : <></>
                                }
                            </ul>
                            <ul>
                                {
                                    nonLiveList
                                        &&
                                        nonLiveList.length
                                        ? nonLiveList.map((li, index) => (
                                            <LiveSportsListItem key={index} li={li} />
                                        ))
                                        : <></>
                                }
                            </ul>
                        </>
                    // : <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                    : <ul>
                        {
                            [...Array(20)].map((_, index)=> <LiveSportsListItemPlaceHoder key={index} />)
                        }
                    </ul>

            }
        </div>
    )
}

function LiveSportsListItem({ li }: { li: SportsLiveListType }) {
    const { stream_1, stream_2, stream_3, stream_4, set_recentUrl, AddViewUrl } = useContext(LiveStreamContext)
    const [selected, setSelected] = useState<boolean>(false)
    const scheduleDateTime = li.date

    const t = useTranslations('Text')
    const a = useTranslations('Sentence')

    useEffect(() => {
        const streams = [stream_1, stream_2, stream_3, stream_4]
        if (streams.includes(li)) {
            setSelected(true)
        } else {
            setSelected(false)
        }
    }, [stream_1, stream_2, stream_3, stream_4])

    function recentUrlBeforeCheck() {
        if (li.states == 'ING') {
            set_recentUrl(li)
        } else {
            customAlert(a('NotCurrentMatch'), 'warning')
        }
    }
    return (
        <li className={selected ? "selected" : ""} >
            <div className="click-cover" onClick={recentUrlBeforeCheck}></div>
            <div>
                <i className={`--i sports ${li.sports}`}></i>
            </div>
            <div className="thumbnail" >
                {
                    li.thumbnail
                        ? <img src={li.thumbnail} 
                               alt={li.thumbnail} 
                               onError={(e) => {
                                           e.currentTarget.onerror = null;
                                           e.currentTarget.src = defaultThumnail.src;
                                }} />
                        : <div className="empty-thumnail">
                            {
                                li.leagueName == "HD"
                                    ? li.home_name
                                    : li.leagueName
                            }
                        </div>
                }
            </div>
            <div>{li.leagueName}</div>
            {
                li.leagueName == "HD"
                    ? <>
                        <div>-</div>
                        <div>{li.home_name}</div>
                    </>
                    : <>
                        <div>{scheduleDateTime}</div>
                        <div>{li.home_name} {li.away_name ? `Vs ${li.away_name}` : ""}</div>
                    </>
            }
            <div className="live">
                {
                    li.states == 'ING' && li.video
                        ? <>
                            <img src={live.src} alt="live" />
                            <MultiSelect listItem={li} />
                        </>
                        : <span className="ready-live">{t('대기중')}</span>
                }
                {/* <button>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button> */}
            </div>
        </li>
    )
}

function LiveSportsListItemPlaceHoder() {
    return (
        <li className="placeholder">
            <div></div>
            <div className="thumbnail"></div>
            <div></div>
            <div></div>
            <div></div>
            <div className="live">
                <img src={live.src} alt="live" />
                <div className="multi-select">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </li>
    )
}